<ds-form-field [optionalText]="' '">
    <label
        ds-label
        *ngIf="label"
        [for]="inputId">
        {{ label | translate }}
    </label>
    <textarea
        ds-input
        [id]="inputId"
        [size]="'md'"
        [ds-autosize]="autoSize"
        [ds-char-limit]="charLimit"
        [required]="required"
        [readonly]="readOnly"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [title]="value"
        [(ngModel)]="value"
        (ngModelChange)="valueChanged.emit($event)"
        (blur)="blurEvent.emit()"
        >{{ value }}</textarea
    >
</ds-form-field>
